// extracted by mini-css-extract-plugin
export default {"item":"components-hotel-short-term-rental-fixed-kpi-header-item-module__item","name":"components-hotel-short-term-rental-fixed-kpi-header-item-module__name"};